<script setup lang="ts">

import { usePresentation, DefaultSections } from '@presentation/Types';
import IntroductionPageOptions from '@presentation/Components/IntroductionPageOptions.vue';
const presentation = usePresentation();

</script>

<template>

    <div class="flex flex-col min-h-full grow items-center justify-center gap-8">
        
        <Image src="/carbucks-driven-by-presidian.png" class="w-4/5 md:w-3/5 lg:w-2/5" />

        <h1 class="text-2xl md:text-3xl lg:text-4xl font-semibold uppercase opacity-30 text-center">
            Welcome to Carbucks!
        </h1>

        <IntroductionPageOptions />

        <button 
            @click.stop="() => presentation.goto( presentation.sections[ 1 ].name )"
            class="bg-cyan-500 hover:brightness-110 rounded-md p-4 shadow tracking-wider font-semibold uppercase mt-4">
            Start Presentation
        </button>

        <button @click="presentation.toggleFullscreen" class="hidden lg:block tracking-wider -mt-4 opacity-60">
            Toggle Fullscreen
        </button>

        <RouterLink to="/" class="absolute bottom-4 opacity-50">www.carbucks.com.au</RouterLink>

    </div>

</template>